import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetSettingsCompleteAsDictionaryResponse
  extends BackendResponse {
  item: CvpSettingsFromServer;
}

export interface GetSettingsCompleteAsDictionaryParameters
  extends NextApiParams {
  idEmbed: string | null;
}

export const getSettingsCompleteAsDictionary = withNextApi<
  GetSettingsCompleteAsDictionaryResponse,
  GetSettingsCompleteAsDictionaryParameters
>("/CvpSettings/CvpGetSettingsCompleteAsDictionary", { method: "GET" });

export interface CvpSettingsFromServer {
  [key: string]: any;
}
